/**
 * Vitonnix Subscription System
 * File: assets/vitonnix-subscription.js
 * 
 * Flow:
 * 1. Customer selects "Subscribe & Save" on product page
 * 2. Clicks "Subscribe Now"
 * 3. Razorpay subscription window opens
 * 4. Customer completes UPI Autopay / Card mandate
 * 5. Subscription is created in Razorpay
 * 6. Webhook notifies your server to create Shopify order
 */

// ============================================================
// CONFIG — Replace with your actual values
// ============================================================
const VT_CONFIG = {
  razorpay_key: 'rzp_live_ST5QRgZKKbFkau', // Your Razorpay Key ID
  store_name: 'Vitonnix',
  store_logo: 'https://vitonnix.in/logo.png',  // Your logo URL
  discount_percent: 10,
  currency: 'INR',
  support_email: 'support@vitonnix.in',
  support_contact: '9041888279', // Your support number

  // Razorpay Plan IDs — Create these in Razorpay Dashboard
  // Dashboard > Subscriptions > Plans > Create Plan
  // One plan per product per frequency
  // Format: 'shopify_product_id_months': 'razorpay_plan_id'
  plans: {
    // Monthly plans (1 month)
    '8158342905996': 'plan_SY8kKrWSIVQ6Fl',
    // 'SHOPIFY_PRODUCT_ID_3': 'plan_XXXXXXXXXXXXXXX',
    // Add all 15 products here after creating plans in Razorpay
  }
};

// ============================================================
// TOGGLE: One-time vs Subscribe
// ============================================================
function vtSelectType(type, productId) {
  const modeInput = document.getElementById(`vt-mode-${productId}`);
  const subOptions = document.getElementById(`vt-sub-options-${productId}`);
  const onetimeBtn = document.getElementById(`vt-onetime-${productId}`);
  const subscribeBtn = document.getElementById(`vt-subscribe-${productId}`);
  const normalAtc = document.getElementById(`vt-normal-atc-${productId}`);
  const subscribeAtc = document.getElementById(`vt-subscribe-atc-${productId}`);

  if (type === 'subscribe') {
    modeInput.value = 'subscribe';
    subscribeBtn.classList.add('vt-active');
    onetimeBtn.classList.remove('vt-active');
    subOptions.style.display = 'block';
    if (normalAtc) normalAtc.style.display = 'none';
    if (subscribeAtc) subscribeAtc.style.display = 'flex';
  } else {
    modeInput.value = 'onetime';
    onetimeBtn.classList.add('vt-active');
    subscribeBtn.classList.remove('vt-active');
    subOptions.style.display = 'none';
    if (normalAtc) normalAtc.style.display = 'flex';
    if (subscribeAtc) subscribeAtc.style.display = 'none';
  }
}

// ============================================================
// FREQUENCY SELECTION
// ============================================================
function vtSelectFreq(btn, productId, months) {
  // Update active button
  const grid = btn.closest('.vt-frequency-grid');
  grid.querySelectorAll('.vt-freq-btn').forEach(b => b.classList.remove('vt-freq-active'));
  btn.classList.add('vt-freq-active');

  // Store frequency
  document.getElementById(`vt-freq-months-${productId}`).value = months;

  // Update price display
  vtUpdatePriceDisplay(productId);
}

// ============================================================
// UPDATE PRICE DISPLAY
// ============================================================
function vtUpdatePriceDisplay(productId) {
  const priceInput = document.getElementById(`vt-product-price-${productId}`);
  if (!priceInput) return;

  const basePrice = parseInt(priceInput.value) / 100; // Shopify stores in paisa
  const discount = (basePrice * VT_CONFIG.discount_percent) / 100;
  const finalPrice = basePrice - discount;

  const origEl = document.getElementById(`vt-orig-${productId}`);
  const discountEl = document.getElementById(`vt-discount-${productId}`);
  const finalEl = document.getElementById(`vt-final-${productId}`);

  if (origEl) origEl.textContent = `₹${basePrice.toFixed(2)}`;
  if (discountEl) discountEl.textContent = `-₹${discount.toFixed(2)}`;
  if (finalEl) finalEl.textContent = `₹${finalPrice.toFixed(2)}`;
}

// ============================================================
// INITIATE RAZORPAY SUBSCRIPTION
// ============================================================
async function vtInitiateSubscription(productId) {
  const productTitle = document.getElementById(`vt-product-title-${productId}`)?.value;
  const priceInput = document.getElementById(`vt-product-price-${productId}`);
  const freqMonths = document.getElementById(`vt-freq-months-${productId}`)?.value || 1;
  const variantId = document.getElementById(`vt-variant-id-${productId}`)?.value;

  if (!priceInput) {
    alert('Product price not found. Please refresh and try again.');
    return;
  }

  const basePrice = parseInt(priceInput.value); // in paisa
  const discountedPrice = Math.round(basePrice * (1 - VT_CONFIG.discount_percent / 100));

  // Get Razorpay Plan ID
  // Plan key = productId_freqMonths
  const planKey = `${productId}_${freqMonths}`;
  const planId = VT_CONFIG.plans[planKey];

  if (!planId) {
    // If no plan found, show setup message
    alert(`Subscription plan not configured yet for this product.\nPlease contact support: ${VT_CONFIG.support_email}`);
    console.warn(`[Vitonnix] No Razorpay plan found for key: ${planKey}`);
    console.warn('[Vitonnix] Create a plan in Razorpay Dashboard and add it to VT_CONFIG.plans');
    return;
  }

  // Get customer info from Shopify (if logged in)
  const customer = window.__st?.a || {};

  // Razorpay Subscription Options
  const options = {
    key: VT_CONFIG.razorpay_key,
    subscription_id: null, // Will be created via your backend
    name: VT_CONFIG.store_name,
    description: `${productTitle} — Monthly Subscription`,
    image: VT_CONFIG.store_logo,
    handler: function(response) {
      vtSubscriptionSuccess(response, productId, variantId, discountedPrice);
    },
    prefill: {
      name: customer.name || '',
      email: customer.email || '',
      contact: customer.phone || ''
    },
    theme: {
      color: '#2D6A4F' // Change to your brand color
    },
    modal: {
      ondismiss: function() {
        console.log('[Vitonnix] Subscription modal closed');
      }
    }
  };

  // ----------------------------------------------------------------
  // OPTION A: If you have a backend/server (Recommended)
  // Call your server to create a Razorpay subscription first,
  // then open Razorpay with the subscription_id
  // ----------------------------------------------------------------
  try {
    const btn = document.getElementById(`vt-subscribe-atc-${productId}`);
    if (btn) {
      btn.textContent = 'Processing...';
      btn.disabled = true;
    }

    // Call your backend to create subscription
    const resp = await fetch('/apps/vitonnix-sub/create-subscription', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        plan_id: planId,
        product_id: productId,
        variant_id: variantId,
        quantity: 1,
        total_count: 120, // 120 months = 10 years (or set as needed)
        customer_email: customer.email || ''
      })
    });

    if (!resp.ok) throw new Error('Failed to create subscription');

    const data = await resp.json();
    options.subscription_id = data.subscription_id;

    // Open Razorpay
    const rzp = new Razorpay(options);
    rzp.open();

    if (btn) {
      btn.innerHTML = '<span class="vt-sub-icon">🔄</span> Subscribe Now — Save 10%';
      btn.disabled = false;
    }

  } catch (err) {
    console.error('[Vitonnix] Subscription error:', err);

    // ----------------------------------------------------------------
    // OPTION B: Direct Razorpay Subscription Link (Fallback)
    // If no backend, redirect to Razorpay payment page directly
    // ----------------------------------------------------------------
    const subscribeBtn = document.getElementById(`vt-subscribe-atc-${productId}`);
    if (subscribeBtn) {
      subscribeBtn.innerHTML = '<span class="vt-sub-icon">🔄</span> Subscribe Now — Save 10%';
      subscribeBtn.disabled = false;
    }

    alert('Unable to process subscription. Please try again or contact support.');
  }
}

// ============================================================
// SUBSCRIPTION SUCCESS HANDLER
// ============================================================
function vtSubscriptionSuccess(response, productId, variantId, discountedPrice) {
  console.log('[Vitonnix] Subscription successful:', response);

  // Show success message
  vtShowSuccessModal(response);

  // Optional: Add to Shopify cart as a note
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: 1,
        properties: {
          '_subscription': 'true',
          '_razorpay_subscription_id': response.razorpay_subscription_id,
          '_subscription_frequency': document.getElementById(`vt-freq-months-${productId}`)?.value + ' month(s)',
          '_discounted_price': `₹${(discountedPrice / 100).toFixed(2)}`
        }
      }]
    })
  }).catch(err => console.warn('[Vitonnix] Cart add failed:', err));
}

// ============================================================
// SUCCESS MODAL
// ============================================================
function vtShowSuccessModal(response) {
  // Remove existing modal
  const existing = document.getElementById('vt-success-modal');
  if (existing) existing.remove();

  const modal = document.createElement('div');
  modal.id = 'vt-success-modal';
  modal.innerHTML = `
    <div class="vt-modal-overlay" onclick="document.getElementById('vt-success-modal').remove()">
      <div class="vt-modal-box" onclick="event.stopPropagation()">
        <div class="vt-modal-icon">✅</div>
        <h2>Subscription Activated!</h2>
        <p>Your monthly subscription has been set up successfully.</p>
        <div class="vt-modal-detail">
          <strong>Subscription ID:</strong><br>
          <code>${response.razorpay_subscription_id}</code>
        </div>
        <p class="vt-modal-note">You will receive a confirmation email shortly. Your product will be auto-delivered every month.</p>
        <button onclick="document.getElementById('vt-success-modal').remove()" class="vt-modal-close">Continue Shopping</button>
      </div>
    </div>
  `;
  document.body.appendChild(modal);
}

// ============================================================
// LOAD RAZORPAY SDK
// ============================================================
(function loadRazorpay() {
  if (document.getElementById('razorpay-sdk')) return;
  const script = document.createElement('script');
  script.id = 'razorpay-sdk';
  script.src = 'https://checkout.razorpay.com/v1/checkout.js';
  script.async = true;
  document.head.appendChild(script);
})();
